import { RestrictedReservation as RestrictedReservationModel } from "../../calendar/model";
import { useTranslation } from "react-i18next";

interface Props {
    reservation: RestrictedReservationModel;
}

const RestrictedReservation = ({ reservation: { start, end } }: Props) => {
    const { t } = useTranslation();

    return(
        <>
            <div>{`${start} - ${end}`}</div>
            <strong>
                {t('no_access')}
            </strong>
        </>
    )
};

export default RestrictedReservation;
